import { useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';

const useToken = (): string | null => {
    const [token, setToken] = useState<string | null>(null);

    const fetchAuthToken = async (): Promise<void> => {
        try {
            const session = await Auth.currentSession().catch(() => {
                setToken('expired');
                throw new Error('Session expired');
            });
            const idToken = session.getIdToken();
            const jwtToken = idToken.getJwtToken();

            if (idToken.getExpiration() * 1000 <= Date.now()) {
                setToken('expired');
            } else {
                setToken(jwtToken);
            }
        } catch (e) {
            setToken('expired');
        }
    };

    useEffect(() => {
        fetchAuthToken();
    }, [setToken]);

    return token;
};

export default useToken;
